import { Route } from '@angular/router';
import {CONTENT_ROUTE} from "./components/layout/content-layout.route";
import {FULL_ROUTES} from "./components/layout/full-layout.routes";
import {HOME_PATH} from "../../../values/path";

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: HOME_PATH,
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./components/layout/full-layout/full-layout.component').then(
        (fullLayoutModule) => fullLayoutModule.FullLayoutComponent,
      ),
    children: FULL_ROUTES,
  },
  {
    path: '',
    loadComponent: () =>
      import(
        './components/layout/content-layout/content-layout.component'
        ).then(
        (contentLayoutModule) => contentLayoutModule.ContentLayoutComponent,
      ),
    children: CONTENT_ROUTE,
  }
];
